type Listener = () => void;

const listeners = new Set<Listener>();

/** Notify Daily spend / Home teasers after alert create/update/delete. */
export function notifySpendAlertsChanged(): void {
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      // ignore listener errors
    }
  });
}

export function subscribeSpendAlertsChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
